export default __webpack_public_path__ + "static/media/green-horizontal-bars.3089fc19.svg";